var map = {
	"./DSC_5997sb12345.png": 813,
	"./Logo.svg": 473,
	"./appd.png": 2840,
	"./armo.png": 2820,
	"./arrow.svg": 2429,
	"./aws.png": 6072,
	"./calico.png": 3903,
	"./circle1.png": 8972,
	"./cisco.png": 4111,
	"./codefresh.png": 1402,
	"./crowdstrike.png": 9093,
	"./datree.png": 1127,
	"./dell.png": 900,
	"./delphix.png": 5880,
	"./dimitri1-M.png": 546,
	"./dimitri1.png": 3404,
	"./dimitri2-M.png": 5753,
	"./dimitri2.png": 3312,
	"./dyna.png": 1070,
	"./edb.png": 9553,
	"./facebook.png": 1869,
	"./fortinet.png": 8168,
	"./george1-M.png": 2052,
	"./george1.png": 6956,
	"./george2-M.png": 2591,
	"./george2.png": 1953,
	"./google.png": 6176,
	"./haproxy.png": 7525,
	"./hp.png": 3938,
	"./inst.png": 8131,
	"./kasten.png": 783,
	"./lenovo.png": 6442,
	"./levan1-M.png": 6898,
	"./levan1.png": 2665,
	"./levan2-M.png": 5197,
	"./levan2.png": 9225,
	"./linkedin.png": 9654,
	"./logsign.png": 4955,
	"./map-marker-icon.png": 9761,
	"./mikheil1-M.png": 8820,
	"./mikheil1.png": 1406,
	"./mikheil2-M.png": 7527,
	"./mikheil2.png": 3942,
	"./natia1-M.png": 4903,
	"./natia1.png": 4519,
	"./natia2-M.png": 3813,
	"./natia2.png": 6580,
	"./netwrix.svg": 7726,
	"./nika1-M.png": 4180,
	"./nika1.png": 1718,
	"./nika2-M.png": 7595,
	"./nika2.png": 1819,
	"./okta.png": 7160,
	"./oracle.png": 9303,
	"./path53690.svg": 6409,
	"./proxmox.png": 6159,
	"./rancher.png": 9704,
	"./residence.png": 2227,
	"./solo.io.png": 5988,
	"./sonatype.png": 7913,
	"./techseed.svg": 6222,
	"./tenable.png": 3188,
	"./vasili1-M.png": 3436,
	"./vasili1.png": 4471,
	"./vasili2-M.png": 9351,
	"./vasili2.png": 7071,
	"./veeam.png": 7132,
	"./vmware.png": 4442,
	"./wallix.png": 1690,
	"./wregra1.png": 2028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3581;